import { Component, OnInit, Input, Output, EventEmitter, ViewChild, SimpleChange } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SortService } from '@app/components/sorting/SortService';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { MessageService, SelectItem } from 'primeng/api';

interface IYear {
  year: number;
}

interface Institution {
  id: number;
  shortName: string;
  name: string;
  noOfMembers: number;
}

@Component({
  selector: 'app-common-search-view',
  templateUrl: './common-search-view.component.html',
  styleUrls: ['./common-search-view.component.css']
})

export class CommonSearchViewComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() header: string;
  @Input() districts: Boolean;
  @Input() multiple;
  @Input() singleyear;
  @Input() showSpinner: Boolean;
  @Output() createReport = new EventEmitter();
  @Output() clearReportView = new EventEmitter();
  @ViewChild('listbox') lb;
  displayInstitutions = false;
  selectedinstitutions: any[] = [];
  lodges: SelectItem[];
  camps: SelectItem[];
  rangeValues: number[] = [1900, new Date().getFullYear()];
  years: IYear[] = [];
  selectedyears: IYear[] = [];
  selectedyear;
  selectedfilter;
  institutionlist: Institution[] = [];
  selectedinstitution;
  selectedDistrict;
  selected;
  institutionslist: SelectItem[] = [];
  districtslist: SelectItem[] = [];
  districtlist: Institution[] = [];
  causes;


  constructor(
    private institutionService: InstitutionsService,
    private messageService: MessageService) { }

  ngOnInit() {
    if (this.header === 'Orsaker') {
      this.getCauses();
    }
    this.getAllInstitutions();
    this.getAllDistricts();
    for (let i = this.rangeValues[1]; i > this.rangeValues[0] - 1; i--) {
      this.years.push({ year: i });
    }
    this.lodges = [{ label: 'Bröder', value: 'b' }, { label: 'Systrar', value: 'r' }];
    this.camps = [{ label: 'Bröder', value: 'bl' }, { label: 'Systrar', value: 'rl' }];
  }

  getCauses() {
    this.institutionService.getEntryExitCauses().subscribe(response => {
      if (response) {
        this.causes = response;
      }
    });
  }

  getAllDistricts() {
    this.institutionService.GetAllDistrictsAsync(0).subscribe(response => {
      this.districtlist = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
      this.districtlist.forEach(x => {
        x.name = x.shortName + ' ' + x.name;
      });
      this.districtlist.forEach(c => {
        this.districtslist.push({ label: c.name, value: c.id });
      });
    });
  }

  getAllInstitutions() {
    this.institutionService.getInstitutions().subscribe(response => {
      this.institutionlist = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
      this.institutionlist.forEach(x => {
        x.name = x.shortName + ' ' + x.name;
      });
      if (!this.districts) {
        this.institutionlist = this.institutionlist.filter(x => ((x.name)).toLowerCase().indexOf('distrikt') === -1);
      }
      const removelist = ['AV1', 'AVGBREV1', 'UT1', 'EL', 'ELA', 'K', 'RLK1', 'RR1', 'SOFT1', 'SOFT2', 'SGL1'];
      if (this.header !== 'Orsaker') {
        removelist.push('SL1');
      }
      this.institutionlist = this.institutionlist.filter(x => {
        return removelist.indexOf(x.shortName) === -1;
      });
      this.institutionlist.forEach(c => {
        this.institutionslist.push({ label: c.name, value: c.id });
      });
    });
  }

  setSelectedInstitutions(evt, institutionlist) {
    switch (institutionlist) {
      case 'institution': this.selectedinstitutions = evt;
        break;
    }
  }

  setDistrict(evt) {
    this.selectedDistrict = evt.value;
    const dist = [];
    evt.value.forEach(x => {
      dist.push(x.id);
    });
    this.form.patchValue({ districts: dist });
  }

  setInstitution(evt) {
    this.selectedinstitution = evt.value;
    const inst = [];
    evt.value.forEach(x => {
      inst.push(x.id);
    });
    this.form.patchValue({ institutions: inst });
  }

  setSingleInstitution() {
    if (this.selected) {
      const inst = [];
      inst.push(this.selected.value);
      this.form.patchValue({ institutions: inst });
    }
  }

  setSingleDistrict() {
    if (this.selected) {
      const dist = [];
      dist.push(this.selected);
      this.form.patchValue({ districts: dist });
    }
  }

  search() {
    this.createReport.emit(this.form);
  }

  removeSelectedInstitution(id: number) {
    const idx = this.selectedinstitutions.findIndex(x => x.id === id);
    this.selectedinstitutions.splice(idx, 1);
    this.setInstitutions();
  }

  setYears() {
    if (this.header !== 'Åldersfördelning' || (this.header === 'Åldersfördelning' && this.selectedyears.length < 16)) {
      const years: any[] = [];
      if (this.selectedyears.length !== 0) {
        this.selectedyears.forEach(y => {
          years.push(y.year);
        });
      } else {
        if (this.selectedyear > this.rangeValues[0] && this.selectedyear < this.rangeValues[1] + 1) {
          years.push(Number(this.selectedyear));
        }
      }
      this.form.patchValue({ selectedYears: years });
    } else {
      this.selectedyears.pop();
      this.messageService.add({ severity: 'warn', summary: 'Information', detail: 'Välj max 15 år' });
    }
  }

  selectLast15Years() {
    const years: any[] = [];
    this.selectedyears = [];
    const currentYear = new Date().getFullYear();
    for (let i = currentYear; i > currentYear - 15; i--) {
      years.push(i);
      this.selectedyears.push({ year: i });
    }
    this.form.patchValue({ selectedYears: years });
  }

  setInstitutions() {
    const institutions: any[] = [];
    this.selectedinstitutions.forEach(i => {
      institutions.push(i.id);
    });
    this.form.get('institutions').patchValue(institutions);
  }

  reset(evt) {
    const resetform = {
      lodges: null,
      camps: null,
      institutions: [],
      parentInstitutionId: null,
      selectedYears: [],
      districts: []
    };
    this.selectedinstitution = null;
    if (evt.value !== 3) {
      this.selected = null;
      this.form.get('institutions').patchValue({ institutions: [] });
    }
    if (evt.value !== 4) {
      this.selected = null;
      this.form.get('districts')?.patchValue({ districts: [] });
    }
    this.form.patchValue(resetform);

  }

  clearReport() {
    this.selectedinstitution = null;
    this.selectedyear = null;
    this.clearReportView.emit();
  }
}
